const config = {
  env: 'prod',
  // env: 'testbed',
  // env: 'uat',
  // env:'sit',
  // other data here
}

export default config
